import { render, staticRenderFns } from "./auth-layout.vue?vue&type=template&id=786efc99&scoped=true&"
import script from "./auth-layout.vue?vue&type=script&lang=js&"
export * from "./auth-layout.vue?vue&type=script&lang=js&"
import style0 from "./auth-layout.vue?vue&type=style&index=0&id=786efc99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786efc99",
  null
  
)

export default component.exports
import {QAvatar,QSeparator,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QAvatar,QSeparator,QBtn})
